import { render, staticRenderFns } from "./GanjoorFrame.vue?vue&type=template&id=27eaf534&scoped=true&"
import script from "./GanjoorFrame.vue?vue&type=script&lang=js&"
export * from "./GanjoorFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27eaf534",
  null
  
)

export default component.exports